<template>
    <a-drawer placement="right" :closable="true" :visible="visible" :width="drawerWidth" destroyOnClose
        :forceRender="true" :bodyStyle="bodyStyle" :wrapStyle="wrapStyle" wrapClassName="drawer" @close="onClose">
        <div class="drawer-box" style="width:100%;height:100%;padding: 12px;">
            <a-tabs :default-active-key="tabIndex" @change="onTabChange">
                <a-tab-pane key="0" tab="销售月计划明细">
                    <a-form-model layout="inline" style="margin-bottom: 1em;">
                        <a-form-model-item label="物料">
                            <a-input style="width:200px" placeholder="物料名称/物料编码" @pressEnter="getData()"
                                v-model="search.materialKeyword" />
                        </a-form-model-item>
                        <a-form-model-item label="配方">
                            <a-input style="width:200px" placeholder="配方名称/配方编码" @pressEnter="getData()"
                                v-model="search.nhfFormulaKeyword" />
                        </a-form-model-item>
                        <a-form-model-item>
                            <a-space>
                                <a-button type="primary" @click="getData()">查询</a-button>
                                <a-button @click="resetList">清空</a-button>
                            </a-space>
                        </a-form-model-item>
                    </a-form-model>
                    <a-table :columns="tableColumns" :loading="tableLoading" :data-source="tableData" bordered
                        :pagination="pagination" :scroll="{ x: 1130, y: 500 }" rowKey="id" @change="onTableChange">
                    </a-table>
                </a-tab-pane>
                <a-tab-pane key="1" tab="原料采购预测" force-render>
                    <a-form-model layout="inline" style="margin-bottom: 1em;">
                        <a-form-model-item label="物料">
                            <a-input style="width:200px" placeholder="物料名称/物料编码" @pressEnter="getData()"
                                v-model="search.materialKeyword" />
                        </a-form-model-item>
                        <a-form-model-item>
                            <a-space>
                                <a-button type="primary" @click="getData()">查询</a-button>
                                <a-button @click="resetList">清空</a-button>
                            </a-space>
                        </a-form-model-item>
                    </a-form-model>
                    <a-table :columns="tableColumns" :loading="tableLoading" :data-source="tableData" bordered
                        :pagination="pagination" :scroll="{ x: 1130, y: 500 }" rowKey="id" @change="onTableChange">
                    </a-table>
                </a-tab-pane>
            </a-tabs>
        </div>

        <template #title>
            <b>查看</b>
        </template>
        <footer>
            <div style="width:100%;">
                <a-button style="height: 32px;width: 66px;" @click="onClose">关闭</a-button>
            </div>
        </footer>
    </a-drawer>
</template>

<script>
import { tableMixins } from '@/Utils/tableMixins.js';

const tableColumns_0 = [
    {
        title: '计划期间',
        dataIndex: 'monthName',
        align: 'center',
        ellipsis: true,
    },
    {
        title: '物料名称',
        dataIndex: 'materialName',
        align: 'center',
        ellipsis: true,
    },
    {
        title: '物料编码',
        dataIndex: 'materialCode',
        align: 'center',
        ellipsis: true,
        width: 120
    },
    {
        title: 'NHF配方名称',
        dataIndex: 'nhfFormulaName',
        align: 'center',
        ellipsis: true,
    },
    {
        title: 'NHF配方代码',
        dataIndex: 'nhfFormulaCode',
        align: 'center',
        ellipsis: true,
    },
    {
        title: '预计全月销量',
        dataIndex: 'estimatedSalesQty',
        align: 'center',
        ellipsis: true,
        width: 120
    },
    {
        title: '预计后期销量',
        dataIndex: 'expectLaterSale',
        align: 'center',
        ellipsis: true,
        width: 120
    },
    {
        title: '单位',
        dataIndex: 'weightUnit',
        align: 'center',
        ellipsis: true,
        width: 60
    }
];

const tableColumns_1 = [
    {
        title: "计划期间",
        align: 'center',
        dataIndex: "monthName",
        ellipsis: true,
    },
    {
        title: "物料名称",
        align: 'center',
        dataIndex: "rowMaterialName",
        ellipsis: true,
    },
    {
        title: "物料编码",
        align: 'center',
        dataIndex: "rowMaterialCode",
        ellipsis: true,
    },
    {
        title: "预计至月末无合同采购均价",
        align: 'center',
        dataIndex: "endingPeriodPurchasePrice",
        ellipsis: true,
    },
    {
        title: "币种",
        align: 'center',
        dataIndex: "priceCurrency",
        ellipsis: true,
        width: 120
    }
];

export default {
    mixins: [tableMixins],
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        monthId: {
            type: Number,
            default: null
        }
    },
    data() {
        return {
            limsSource: 1,
            wrapStyle: {
                overflow: 'hidden'
            },
            bodyStyle: {
                overflow: 'hidden',
            },
            drawerWidth: 1200,

            tableColumns_0,
            tableColumns_1,
            tableLoading: false,
            tableColumns: tableColumns_0,
            tableData: [],

            tabIndex: 0,
            search: {}
        };
    },
    watch: {
        visible(val) {
            if (val) {
                this.getData();
            }
        },
    },
    mounted() {
        const viewportWidth = window.innerWidth;
        const _width = viewportWidth * 0.8;
        if (_width < 1200) {
            this.drawerWidth = _width;
        }
    },
    methods: {
        // 获取表格
        getData(pagination) {
            this.tableData = [];
            this.tableColumns = this[`tableColumns_${this.tabIndex}`];
            let { current, pageSize } = pagination || this.pagination;
            const data = {
                current: current,
                size: pageSize,
                monthId: this.monthId,
                ...this.search
            };
            const urls = [
                '/nhf-value-estimate/api/friday/calculate/sales/planProductDetail',
                '/nhf-value-estimate/api/friday/calculate/sales/planRawDetail'
            ];
            this.tableLoading = true;
            this.$get(urls[this.tabIndex], data).then(res => {
                let { data, success, msg } = res || {};
                if (success) {
                    let { records, total = 0, current = 1, size } = data || {};
                    this.tableData = records;
                    this.setPagination({ total, current, size });
                } else {
                    this.$message.error(msg);
                }
                this.tableLoading = false;
            });
        },

        onTabChange(index) {
            this.tabIndex = index;
            this.resetList();
        },

        onTableChange(pagination) {
            this.getData(pagination);
        },

        resetList() {
            this.search = {};
            this.getData();
        },

        onClose() {
            this.tabIndex = 0;
            this.search = {};
            this.$emit('close');
        },
    }
};
</script>


<style lang="scss" scoped>
.containers {
    width: 100%;
    flex: 1;
    height: calc(100vh - 100px);
}

::v-deep .drawer {
    overflow: hidden;

    .ant-drawer-wrapper-body,
    .ant-drawer-wrapper-body {
        overflow: hidden;
    }
}

::v-deep .ant-checkbox-wrapper-disabled {
    display: none;
}

footer {
    position: absolute;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 56px;
    border-top: 1px solid #e9e9e9;
    box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.08);
    padding: 10px 16px;
    background: #fff;
    text-align: right;
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .ant-btn {
        margin-right: 20px;
        min-width: 60px;
    }
}
</style>
